import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock, vModelText as _vModelText, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ce24bba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hero" }
const _hoisted_2 = { class: "hero-body" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "header is-flex is-justify-content-space-between" }
const _hoisted_6 = { class: "title is-4" }
const _hoisted_7 = {
  key: 0,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_8 = {
  key: 1,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_9 = {
  key: 2,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_10 = {
  key: 3,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_11 = {
  key: 4,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_12 = { class: "content-body" }
const _hoisted_13 = {
  key: 0,
  class: "table"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = {
  key: 1,
  class: ""
}
const _hoisted_18 = {
  key: 2,
  class: ""
}
const _hoisted_19 = {
  key: 3,
  class: ""
}
const _hoisted_20 = {
  key: 4,
  class: ""
}
const _hoisted_21 = { key: 5 }
const _hoisted_22 = {
  key: 1,
  class: "field is-grouped mb-4"
}
const _hoisted_23 = { class: "label mr-2" }
const _hoisted_24 = { class: "control" }
const _hoisted_25 = {
  value: "",
  disabled: "",
  selected: ""
}
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  key: 2,
  class: "field is-grouped mb-4"
}
const _hoisted_28 = { class: "label mr-2" }
const _hoisted_29 = { class: "control" }
const _hoisted_30 = { class: "label mr-2" }
const _hoisted_31 = { class: "control" }
const _hoisted_32 = { class: "control" }
const _hoisted_33 = {
  key: 3,
  class: "table-container mb-2",
  style: {"max-height":"420px","overflow-y":"auto"}
}
const _hoisted_34 = { class: "table" }
const _hoisted_35 = { class: "" }
const _hoisted_36 = { class: "" }
const _hoisted_37 = { class: "" }
const _hoisted_38 = { class: "" }
const _hoisted_39 = { class: "" }
const _hoisted_40 = { class: "" }
const _hoisted_41 = { class: "" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_43 = {
  key: 6,
  class: "table"
}
const _hoisted_44 = { class: "" }
const _hoisted_45 = { class: "" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_47 = { class: "header" }
const _hoisted_48 = {
  key: 0,
  class: "title is-5"
}
const _hoisted_49 = { class: "columns" }
const _hoisted_50 = { class: "column" }
const _hoisted_51 = { class: "field" }
const _hoisted_52 = { class: "label" }
const _hoisted_53 = { class: "control" }
const _hoisted_54 = ["placeholder"]
const _hoisted_55 = { class: "column" }
const _hoisted_56 = { class: "field" }
const _hoisted_57 = { class: "label" }
const _hoisted_58 = { class: "control" }
const _hoisted_59 = ["placeholder"]
const _hoisted_60 = { class: "columns" }
const _hoisted_61 = { class: "column" }
const _hoisted_62 = { class: "field" }
const _hoisted_63 = { class: "label" }
const _hoisted_64 = { class: "control" }
const _hoisted_65 = ["placeholder"]
const _hoisted_66 = { class: "column" }
const _hoisted_67 = { class: "field" }
const _hoisted_68 = { class: "label" }
const _hoisted_69 = { class: "control" }
const _hoisted_70 = ["placeholder"]
const _hoisted_71 = {
  key: 0,
  class: "column"
}
const _hoisted_72 = { class: "field" }
const _hoisted_73 = { class: "label" }
const _hoisted_74 = { class: "control" }
const _hoisted_75 = ["placeholder"]
const _hoisted_76 = {
  key: 1,
  class: "column"
}
const _hoisted_77 = { class: "field" }
const _hoisted_78 = { class: "label" }
const _hoisted_79 = { class: "control" }
const _hoisted_80 = ["placeholder"]
const _hoisted_81 = { class: "field is-grouped is-grouped-right" }
const _hoisted_82 = { class: "control" }
const _hoisted_83 = {
  type: "submit",
  class: "button is-primary"
}
const _hoisted_84 = { class: "control" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_UserTableRow = _resolveComponent("UserTableRow")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_MngAppointmentRecordTableRow = _resolveComponent("MngAppointmentRecordTableRow")!
  const _component_AppointmentDataForm = _resolveComponent("AppointmentDataForm")!
  const _component_ProductTableRow = _resolveComponent("ProductTableRow")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Navbar),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t('Management.Mode')), 1),
                (_ctx.getMngMode == 'vets' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_7, _toDisplayString(_ctx.$t('Management.ManageVets')), 1))
                  : _createCommentVNode("", true),
                (_ctx.getMngMode == 'managers' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_8, _toDisplayString(_ctx.$t('Management.ManageManagers')), 1))
                  : _createCommentVNode("", true),
                (_ctx.getMngMode == 'customers' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_9, _toDisplayString(_ctx.$t('Management.VisualizeCustomers')), 1))
                  : _createCommentVNode("", true),
                (_ctx.getMngMode == 'appointments' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_10, _toDisplayString(_ctx.$t('Management.VisualizeAppointments')), 1))
                  : _createCommentVNode("", true),
                (_ctx.getMngMode == 'products' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_11, _toDisplayString(_ctx.$t('Management.ManageProducts')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                (_ctx.getMngMode == 'vets' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "button is-primary",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.iniCreating && _ctx.iniCreating(...args)))
                    }, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('Management.NewVet')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.getMngMode == 'managers' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "button is-primary",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.iniCreating && _ctx.iniCreating(...args)))
                    }, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('Management.NewManager')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.getMngMode != 'appointments' && _ctx.getMngMode != 'products' && !_ctx.creating)
                ? (_openBlock(), _createElementBlock("table", _hoisted_13, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('UserData.Id')), 1),
                        (_ctx.getMngMode != 'customers')
                          ? (_openBlock(), _createElementBlock("th", _hoisted_14, _toDisplayString(_ctx.$t('UserData.Photo')), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('UserData.Name')), 1),
                        _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('UserData.Email')), 1),
                        (_ctx.getMngMode != 'managers')
                          ? (_openBlock(), _createElementBlock("th", _hoisted_17, _toDisplayString(_ctx.$t('UserData.Phone')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.getMngMode == 'customers')
                          ? (_openBlock(), _createElementBlock("th", _hoisted_18, _toDisplayString(_ctx.$t('CustomerData.Address')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.getMngMode == 'vets')
                          ? (_openBlock(), _createElementBlock("th", _hoisted_19, _toDisplayString(_ctx.$t('VetData.Specialty')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.getMngMode == 'customers')
                          ? (_openBlock(), _createElementBlock("th", _hoisted_20, _toDisplayString(_ctx.$t('CustomerData.VATNumber')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.getMngMode != 'customers')
                          ? (_openBlock(), _createElementBlock("th", _hoisted_21, _toDisplayString(_ctx.$t('General.Operations')), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUsers, (user) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: user.user_id
                        }, [
                          _createVNode(_component_UserTableRow, {
                            "user-data": user,
                            parentShowCustomerData: _ctx.showCustomerData
                          }, null, 8, ["user-data", "parentShowCustomerData"])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.getMngMode == 'appointments' && !_ctx.getShowingAppointmentData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('Management.OfVet')), 1),
                    _createElementVNode("div", _hoisted_24, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterVetUserId) = $event)),
                        required: "",
                        class: "select is-fullwidth px-6 is-size-6"
                      }, [
                        _createElementVNode("option", _hoisted_25, _toDisplayString(_ctx.$t('Management.SelectVet')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUsers, (vet) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: vet.user_id,
                            value: vet.user_id
                          }, _toDisplayString(vet.name), 9, _hoisted_26))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.filterVetUserId]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.getMngMode == 'appointments' && !_ctx.getShowingAppointmentData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('General.From')), 1),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_VueDatePicker, {
                        id: "filter_start_date",
                        modelValue: _ctx.filterStartDate,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterStartDate) = $event)),
                        placeholder: _ctx.$t('General.PleaseSelectDate'),
                        "model-type": "yyyy-MM-dd",
                        "auto-apply": "",
                        "min-date": new Date(1950, 0, 1),
                        "max-date": _ctx.maxDate,
                        "enable-time-picker": false,
                        "prevent-min-max-navigation": "",
                        format: "yyyy-MM-dd"
                      }, null, 8, ["modelValue", "placeholder", "min-date", "max-date"])
                    ]),
                    _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('General.To')), 1),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_VueDatePicker, {
                        id: "filter_end_date",
                        modelValue: _ctx.filterEndDate,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterEndDate) = $event)),
                        placeholder: _ctx.$t('General.PleaseSelectDate'),
                        "model-type": "yyyy-MM-dd",
                        "auto-apply": "",
                        "min-date": new Date(1950, 0, 1),
                        "max-date": _ctx.maxDate,
                        "enable-time-picker": false,
                        "prevent-min-max-navigation": "",
                        format: "yyyy-MM-dd"
                      }, null, 8, ["modelValue", "placeholder", "min-date", "max-date"])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("button", {
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args))),
                        class: "button is-light"
                      }, _toDisplayString(_ctx.$t('General.ResetFilter')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.getMngMode == 'appointments' && !_ctx.getShowingAppointmentData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createElementVNode("table", _hoisted_34, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.$t('AppointmentData.Appointment')), 1),
                          _createElementVNode("th", _hoisted_36, _toDisplayString(_ctx.$t('AppointmentData.Vet')), 1),
                          _createElementVNode("th", _hoisted_37, _toDisplayString(_ctx.$t('AppointmentData.Customer')), 1),
                          _createElementVNode("th", _hoisted_38, _toDisplayString(_ctx.$t('AppointmentData.Pet')), 1),
                          _createElementVNode("th", _hoisted_39, _toDisplayString(_ctx.$t('AppointmentData.Price')), 1),
                          _createElementVNode("th", _hoisted_40, _toDisplayString(_ctx.$t('AppointmentData.Status')), 1),
                          _createElementVNode("th", _hoisted_41, _toDisplayString(_ctx.$t('AppointmentData.StatusTime')), 1),
                          _hoisted_42
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAppointments, (appointment) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: appointment.appointment_id
                          }, [
                            _createVNode(_component_MngAppointmentRecordTableRow, { "appointment-data": appointment }, null, 8, ["appointment-data"])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.getMngMode == 'appointments' && _ctx.getShowingAppointmentData)
                ? (_openBlock(), _createBlock(_component_AppointmentDataForm, { key: 4 }))
                : _createCommentVNode("", true),
              (_ctx.getMngMode == 'appointments' && !_ctx.getShowingAppointmentData)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 5,
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.exportAppointmentsToExcel && _ctx.exportAppointmentsToExcel(...args))),
                    class: "button is-primary"
                  }, _toDisplayString(_ctx.$t('Management.ExportToExcel')), 1))
                : _createCommentVNode("", true),
              (_ctx.getMngMode == 'products')
                ? (_openBlock(), _createElementBlock("table", _hoisted_43, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('ProductData.Id')), 1),
                        _createElementVNode("th", _hoisted_44, _toDisplayString(_ctx.$t('ProductData.Designation')), 1),
                        _createElementVNode("th", _hoisted_45, _toDisplayString(_ctx.$t('ProductData.Price')), 1),
                        _hoisted_46
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getProducts, (product) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: product.product_id
                        }, [
                          _createVNode(_component_ProductTableRow, { "product-data": product }, null, 8, ["product-data"])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.creating)
                ? (_openBlock(), _createElementBlock("form", {
                    key: 7,
                    onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createUserMeth && _ctx.createUserMeth(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_47, [
                      (_ctx.getMngMode == 'vets')
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_48, _toDisplayString(_ctx.$t('Management.NewVet')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.$t('UserData.Name')), 1),
                          _createElementVNode("div", _hoisted_53, [
                            _withDirectives(_createElementVNode("input", {
                              minlength: 2,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newUser.name) = $event)),
                              class: "input",
                              type: "text",
                              placeholder: _ctx.$t('UserData.NamePlaceholder'),
                              required: ""
                            }, null, 8, _hoisted_54), [
                              [_vModelText, _ctx.newUser.name]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t('UserData.Email')), 1),
                          _createElementVNode("div", _hoisted_58, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newUser.email) = $event)),
                              class: "input",
                              type: "email",
                              placeholder: _ctx.replaceSpecialCharacters(_ctx.$t('UserData.EmailPlaceholder')),
                              required: ""
                            }, null, 8, _hoisted_59), [
                              [_vModelText, _ctx.newUser.email]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.$t('UserData.Password')), 1),
                          _createElementVNode("div", _hoisted_64, [
                            _withDirectives(_createElementVNode("input", {
                              minlength: 6,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newUser.password) = $event)),
                              class: "input",
                              type: "password",
                              placeholder: _ctx.$t('UserData.PasswordPlaceholder'),
                              required: ""
                            }, null, 8, _hoisted_65), [
                              [_vModelText, _ctx.newUser.password]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.$t('CustomerData.PassConfirmation')), 1),
                          _createElementVNode("div", _hoisted_69, [
                            _withDirectives(_createElementVNode("input", {
                              minlength: 6,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newUser.confirmation) = $event)),
                              class: "input",
                              type: "password",
                              placeholder: _ctx.$t('UserData.PassConfirmationPlaceholder'),
                              required: ""
                            }, null, 8, _hoisted_70), [
                              [_vModelText, _ctx.newUser.confirmation]
                            ])
                          ])
                        ])
                      ]),
                      (_ctx.getMngMode != 'managers')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                            _createElementVNode("div", _hoisted_72, [
                              _createElementVNode("label", _hoisted_73, _toDisplayString(_ctx.$t('UserData.PhoneNumber')), 1),
                              _createElementVNode("div", _hoisted_74, [
                                _withDirectives(_createElementVNode("input", {
                                  minlength: 6,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newUser.phone) = $event)),
                                  class: "input",
                                  type: "phone",
                                  placeholder: _ctx.$t('UserData.PhoneNumberPlaceholder'),
                                  required: ""
                                }, null, 8, _hoisted_75), [
                                  [_vModelText, _ctx.newUser.phone]
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.getMngMode == 'vets')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                            _createElementVNode("div", _hoisted_77, [
                              _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.$t('VetData.Specialty')), 1),
                              _createElementVNode("div", _hoisted_79, [
                                _withDirectives(_createElementVNode("input", {
                                  minlength: 6,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newUser.specialty) = $event)),
                                  class: "input",
                                  type: "test",
                                  placeholder: _ctx.$t('VetData.SpecialtyPlaceholder'),
                                  required: ""
                                }, null, 8, _hoisted_80), [
                                  [_vModelText, _ctx.newUser.specialty]
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("p", _hoisted_82, [
                        _createElementVNode("button", _hoisted_83, _toDisplayString(_ctx.$t('General.Save')), 1)
                      ]),
                      _createElementVNode("p", _hoisted_84, [
                        _createElementVNode("a", {
                          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.toggleCreating && _ctx.toggleCreating(...args))),
                          class: "button is-light"
                        }, _toDisplayString(_ctx.$t('General.Cancel')), 1)
                      ])
                    ])
                  ], 32))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}